<template>

    <vx-card>
        <vs-table noDataText="Ni dodatkov" ref="breakpointsTable" :max-items="50" :data="breakpoints">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center">
                    <vs-button class="mb-3" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addBreakpointPrompt = true">Dodaj</vs-button>
                </div>
            </div>

            <template slot="thead">
                <vs-th sort-key="min_order_price">Minimalno naročilo</vs-th>
                <vs-th sort-key="price_type">Tip cene</vs-th>
                <vs-th sort-key="price">Cena</vs-th>
                <vs-th sort-key="max_kilometers">Do kilometrov</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr.id" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].min_order_price">
                        {{ data[index].min_order_price }}
                    </vs-td>

                    <vs-td v-if="data[index].price_type === 0" :data="data[index].price_type">
                        Cena po kilometru
                    </vs-td>

                    <vs-td v-else :data="data[index].price_type">
                        Fiksna cena
                    </vs-td>

                    <vs-td :data="data[index].price">
                        {{ data[index].price }}
                    </vs-td>

                    <vs-td :data="data[index].max_kilometers">
                        {{ data[index].max_kilometers }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup title="Dodaj tip poti" :active.sync="addBreakpointPrompt">
            <div>
                <p class="mt-6">Minimalno naročilo</p>
                <vs-input v-model="addMinOrderPrice" style="width: 100%"></vs-input>
                <p class="mt-6">Tip cene</p>
                <vs-select class="selectExample" v-model="addPriceType">
                    <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="(item,index) in [{id:0, name:'Cena po kilometru'}, {id:1, name:'Fiksna cena'}]" />
                </vs-select>
                <p class="mt-6">Cena</p>
                <vs-input v-model="addPrice" style="width: 100%"></vs-input>
                <p class="mt-6">Do kilometrov</p>
                <vs-input v-model="addMaxKilometers" style="width: 100%"></vs-input>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addBreakpoint">Dodaj</vs-button>
            </div>
        </vs-popup>

    </vx-card>

</template>
<script>

    export default {
        data(){
            return {

                breakpoints: null,

                addBreakpointPrompt: false,

                addMinOrderPrice: 0,
                addPriceType: 0,
                addPrice: 0,
                addMaxKilometers: 0,

            }
        },
        methods: {
            updateBreakpoints(){
                const thisIns = this;
                this.$http.get('/api/management/v1/shipping_breakpoint/')
                    .then(function (response) {
                        thisIns.breakpoints = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            addBreakpoint(){
                const thisIns = this;
                this.$http.post('/api/management/v1/shipping_breakpoint/', {
                    min_order_price: Number(this.addMinOrderPrice),
                    price_type: Number(this.addPriceType),
                    price: Number(this.addPrice),
                    max_kilometers: Number(this.addMaxKilometers)
                })
                    .then(function () {
                        thisIns.updateBreakpoints();
                        thisIns.addBreakpointPrompt = false;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            },
            removeBreakpoint(id){
                const thisIns = this;
                this.$http.delete('/api/management/v1/shipping_breakpoint/' + id)
                    .then(function () {
                        thisIns.updateBreakpoints();
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title: 'Error',
                            text: error,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        })
                    });
            }
        },
        created() {
            this.updateBreakpoints();
        }
    }

</script>
